import React from 'react';

import axios from "axios";
import {API_BASE_URL, HEADER_TOKEN} from "../../configs/AppConfig";
import {AUTH_TOKEN} from "../constants/Auth";
import {notification, Button} from "antd";
import history from "../../history";
import utils from "../../utils";
import esMessages from "../../lang/locales/es_ES.json";
import enMessages from "../../lang/locales/en_US.json";

// Función simple para obtener traducción por key
export const getMessage = (key) => {
  const locale = localStorage.getItem('locale') || 'es';
  const messages = locale === 'es' ? esMessages : enMessages;
  return messages[key] || key;
};

export const ApiService = axios.create({
  baseURL: API_BASE_URL,
  timeout: 600000
});

const insertProjectAndHospital = (data) => {
  const location = window.location;
  data.id_estudio = utils.getIdProject(location);
  data.id_centro = utils.getIdHospital(location);
  //Replico porque Jesús no pone nunca los mismos nombres Quitar cuando vuelva
  data.estudio = utils.getIdProject(location);
  data.centro = utils.getIdHospital(location);
  return data;
};

ApiService.interceptors.request.use(config => {
  const jwtToken = localStorage.getItem(AUTH_TOKEN);
  if (jwtToken) {
    config.headers[HEADER_TOKEN] = jwtToken;
    config.data = insertProjectAndHospital(config.data);
  }
  config.data.external = process.env.REACT_APP_EXTERNAL === 'true';

  return config
}, error => {
  // Do something with request error here
  notification.error({message: getMessage('api.error.general.message')});
  Promise.reject(error)
});

ApiService.interceptors.response.use(request => {
  if(request.data?.responseNotification ) {
    const key = `open${Date.now()}`;
    // const btn = (
    //   <Button type="primary" size="small" onClick={() => notification.close(key)}>
    //     Revisar
    //   </Button>
    // );
    notification.open({
      type: request.data?.responseNotification?.type,
      message: request.data?.responseNotification?.message,
      description: request.data?.responseNotification?.description,
      key})
  }
  return request;
})

//Si en cualquier llamada me devuelve un forceRedirect, redirijo a esa página
// ApiService.interceptors.response.use(response => {
//   const redirectUrl = response.data?.forceRedirect;
//
//   if (redirectUrl) {
//     const isExternal = /^https?:\/\//.test(redirectUrl); // Verifica si es una URL absoluta
//
//     if (isExternal) {
//       window.location.href = redirectUrl; // Redirige externamente
//     } else {
//       window.location.replace(redirectUrl); // Redirige internamente
//     }
//   }
//   return response;
// });


export const handlerError = (error) => {
  let notificationParam = {
    message: getMessage('api.error.general.message'),
    description: getMessage('api.error.general.description')
  };
  let location = window.location

  // Remove token and redirect
  if (error.response?.status === 401) {
    notificationParam.message = getMessage('api.error.401.message');
    notificationParam.description = getMessage('api.error.401.description');

    const hadToken = localStorage.getItem(AUTH_TOKEN) !== null;
    localStorage.removeItem(AUTH_TOKEN);

    // Si ya no había token, otro 401 paralelo ya gestionó la redirección
    if (hadToken) {
      // Construct redirect URL with query parameter instead of localStorage
      if(!location.pathname.includes('auth')) {
        const originalUrl = encodeURIComponent(location.pathname + location.search);
        const loginUrl = `${utils.getRouteLogin()}?url=${originalUrl}`;
        history.push(loginUrl);
      } else {
        history.push(utils.getRouteLogin());
      }

      //Retraso la carga para que aparezca el mensaje de fallo
      setTimeout(() => location.reload(), 1000);
    }
  }

  if (error.response?.status === 300) {
    notificationParam.message = error.response.data.titulo
    notificationParam.description = error.response.data.descripcion

  }
  if (error.response?.status === 404) {
    notificationParam.message = getMessage('api.error.404.message');
  }

  if (error.response?.status === 500) {
    notificationParam.message = getMessage('api.error.500.message');
  }

  if (error.response?.status === 508) {
    notificationParam.message = getMessage('api.error.508.message');
  }

  notification.error(notificationParam);

  return Promise.reject(error);
};
